import { graphql } from 'react-relay';

export const baseDataChartFragment = graphql`
    fragment BaseDataChart_chart on BaseDataChart {
        text
        level
        levelmax
        leveltext1
        leveltext2
        info
    }
`;
